import React from 'react';
import { useTranslation } from 'react-i18next';
import { ShieldCheck } from 'lucide-react';

export const VerifiedBadge = ({ size = 'sm', showText = true }) => {
  const { t } = useTranslation();

  const sizes = {
    xs: { icon: 12, font: '0.6rem', pad: '0.1rem 0.35rem', gap: '0.15rem' },
    sm: { icon: 14, font: '0.7rem', pad: '0.15rem 0.5rem', gap: '0.2rem' },
    md: { icon: 18, font: '0.85rem', pad: '0.25rem 0.65rem', gap: '0.3rem' },
    lg: { icon: 22, font: '1rem', pad: '0.35rem 0.85rem', gap: '0.4rem' },
  };

  const s = sizes[size] || sizes.sm;

  return (
    <span
      data-testid="verified-badge"
      style={{
        display: 'inline-flex', alignItems: 'center', gap: s.gap,
        padding: s.pad, borderRadius: '20px',
        background: 'linear-gradient(135deg, #dcfce7 0%, #d1fae5 100%)',
        color: '#15803d', fontWeight: 700, fontSize: s.font,
        border: '1px solid #86efac',
        lineHeight: 1.3, whiteSpace: 'nowrap',
      }}
    >
      <ShieldCheck size={s.icon} />
      {showText && t('verification.badge')}
    </span>
  );
};
